import { useState, useRef, useEffect } from "react";
import { useI18n } from "../../i18n";
import { Globe, Check } from "lucide-react";

export default function LanguageSwitcher() {
  const { lang, setLang, languages } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const current = languages.find((l) => l.code === lang) || languages[0];

  return (
    <div ref={ref} className="relative">
      <button
        data-testid="lang-switcher"
        onClick={() => setOpen((v) => !v)}
        className="h-10 px-3 rounded-full border border-[#23232a] hover:border-[color:var(--gold)] flex items-center gap-2 text-xs font-mono uppercase tracking-widest"
      >
        <Globe className="w-3.5 h-3.5 text-[color:var(--gold)]" />
        <span>{current.flag}</span>
        <span className="hidden sm:inline">{current.code.toUpperCase()}</span>
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 w-56 rounded-xl border border-[#23232a] bg-[#0f0f12] shadow-2xl overflow-hidden z-50 max-h-[60vh] overflow-y-auto">
          {languages.map((l) => (
            <button
              key={l.code}
              data-testid={`lang-${l.code}`}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className={`w-full px-4 py-2.5 text-left text-sm flex items-center gap-3 hover:bg-[rgba(231,180,59,.06)] transition-colors ${
                l.code === lang ? "text-[color:var(--gold)]" : "text-[color:var(--ink-dim)]"
              }`}
            >
              <span className="text-base">{l.flag}</span>
              <span className="flex-1">{l.native}</span>
              {l.code === lang && <Check className="w-3.5 h-3.5" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
